import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { Credibility } from "@/components/site/Credibility";
import { Services } from "@/components/site/Services";
import { HowItWorks } from "@/components/site/HowItWorks";
import { Cambridge } from "@/components/site/Cambridge";
import { Trainings } from "@/components/site/Trainings";
import { Philosophy } from "@/components/site/Philosophy";
import { Wellbeing } from "@/components/site/Wellbeing";
import { Testimonials } from "@/components/site/Testimonials";
import { WhyChooseUs } from "@/components/site/WhyChooseUs";
import { FAQ } from "@/components/site/FAQ";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";
import { WhatsAppFab } from "@/components/site/WhatsAppFab";

function App() {
  return (
    <div className="App min-h-screen bg-stone-50 text-stone-900">
      <Navbar />
      <main>
        <Hero />
        <Credibility />
        <Services />
        <HowItWorks />
        <Cambridge />
        <Trainings />
        <Philosophy />
        <Wellbeing />
        <Testimonials />
        <WhyChooseUs />
        <FAQ />
        <Contact />
      </main>
      <Footer />
      <WhatsAppFab />
      <Toaster richColors position="top-right" />
    </div>
  );
}

export default App;
